<div class="storage-full madero-style">
	<div class="app-header u_margin-md-top mb-5">
		<h1 class="app-header-title" id="title">Storage</h1>
	</div>

	<files-list></files-list>

</div>